// ContactMe/ContactMe.jsx
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import BrokerContactComponent from "../../BrokerContactComponent/BrokerContactComponent";
import './ContactMe.css';

const ContactMe = ({ secondsToStart, brokerData }) => {
    return (
        <div className="contact-me-container" id='ContactMeForm'>
            <div className="contact-me-heading">Contact Me</div>

            <div className="contact-form-section">
                <h2 className="get-started-text">
                    Get Started In Less Than <br />
                    <span className="seconds-highlight">{secondsToStart} Seconds</span>
                </h2>

                {/* Placeholder for the common form component */}
                <div className="form-placeholder">
                    <BrokerContactComponent brokerData={brokerData} />
                </div>
            </div>
        </div>
    );
};

export default ContactMe;